module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-12-0590734af6ddfa4fd44273f802b27630.svg";